import * as yup from "yup";
export const IGNORE_ERROR = "IGNORE";

export const FLEET_VEHICLE_OFFER_SALE_ITEM_EDIT_FORM_SCHEMA = yup.object().shape({
    code: yup.string().required("Molimo Vas da unesete šifru"),
    name: yup.string().required("Molimo Vas da unesete naziv"),
    taxRate: yup.string().required("Molimo Vas da PDV %"),
    quantity: yup.string().required("Molimo Vas da unesete količinu"),
    priceWithoutTax: yup.string().required("Molimo Vas da unesete cijenu bez PDV-a"),
    priceWithTax: yup.string().required("Molimo Vas da unesete cijenu sa PDV"),
    discountTypeId: yup.string().required("Molimo Vas da odaberite tip popusta"),
});







